import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const IdealistaSection = ({ idealistaUrl = "https://www.idealista.com/pro/esqque/", style }) => {
    const { t } = useLanguage();

    // Función para reemplazar "Idealista" con el logo
    const renderTitleWithLogo = () => {
        const title = t('idealista.title');
        const parts = title.split('Idealista');

        return (
            <>
                {parts[0]}
                <img
                    src="/img/idealista-logo.svg"
                    alt="Idealista"
                    className="idealista-logo-inline"
                />
                {parts[1]}
            </>
        );
    };

    return (
        <div className="mxd-section overflow-hidden py-4" style={style}>
            <div className="mxd-container">
                <div className="mxd-block">
                    <div className="container-fluid px-0">
                        <div className="row gx-4 justify-content-center">
                            <div className="col-12 col-xl-8 mxd-pricing-table__item mxd-grid-item animate-card-3 p-0">
                                <div className="mxd-pricing-table__inner">
                                    <div className="mxd-pricing-table__data">
                                        <div className="pricing-data__header">
                                            <h4 className="pricing-header__title anim-uni-in-up">
                                                {renderTitleWithLogo()}
                                            </h4>
                                            <p className="pricing-header__description anim-uni-in-up t-bright">
                                                {t('idealista.description')}
                                            </p>
                                        </div>
                                        <div className="pricing-data__info">
                                            <div className="pricing-data__btnholder anim-uni-in-up">
                                                <a
                                                    className="btn btn-anim btn-default btn-opposite btn-fullwidth btn-idealista slide-right-up btn-long-text"
                                                    href={idealistaUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <span className="btn-caption">{t('idealista.button')}</span>
                                                    <i className="ph-bold ph-arrow-up-right"></i>
                                                </a>
                                            </div>
                                            <div className="pricing-data__divider anim-uni-in-up"></div>
                                        </div>
                                    </div>
                                    <div className="mxd-pricing-table__plan">
                                        <p className="pricing-plan__caption t-semibold t-bright anim-uni-in-up">
                                            {t('idealista.what_you_find')}
                                        </p>
                                        <div className="pricing-plan__list">
                                            <ul className="mxd-check-list">
                                                <li className="anim-uni-in-up">
                                                    <i className="ph ph-check"></i>
                                                    <span>{t('idealista.features.locations')}</span>
                                                </li>
                                                <li className="anim-uni-in-up">
                                                    <i className="ph ph-check"></i>
                                                    <span>{t('idealista.features.photos')}</span>
                                                </li>
                                                <li className="anim-uni-in-up">
                                                    <i className="ph ph-check"></i>
                                                    <span>{t('idealista.features.prices')}</span>
                                                </li>
                                                <li className="anim-uni-in-up">
                                                    <i className="ph ph-check"></i>
                                                    <span>{t('idealista.features.detailed_info')}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="mxd-pricing-table__link anim-uni-in-up">
                                        <a
                                            href="https://wa.me/34610683948"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {t('idealista.need_more_info')}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IdealistaSection;
